import { BaseOption } from '@/hooks/useTypeToOptions';
import { Tag } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { ReactNode } from 'react';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

export type AlreadySharedDecoration = {
  disabled: true;
  render: () => ReactNode;
};

/**
 * Builds a `decorateOption` for `OfficeMember`: already-shared members are
 * disabled and re-rendered with an "already shared" tag instead of the
 * normal selectable checkbox row.
 *
 * `OfficeMember.decorateOption` reaches past its own public `BaseOption`
 * type into the underlying select's undocumented `option.data.disabled` /
 * `option.data.render` fields — see the JSDoc there. This function is
 * unit-tested on its own (rather than only exercised via a Storybook story)
 * so a change to that coupling shows up as a test failure, not just a
 * visual regression.
 */
export const createAlreadySharedOptionDecorator =
  (registeredIds: Set<string>, alreadySharedLabel: ReactNode) =>
  (option: BaseOption): AlreadySharedDecoration | undefined => {
    if (!registeredIds.has(String(option.value))) return undefined;
    return {
      disabled: true,
      render: () => (
        <div className={cx(styles.alreadySharedOption)}>
          <div>
            <div className={option.caption ? cx(styles.label) : undefined}>
              {option.label}
            </div>
            {option.caption && (
              <div className={cx(styles.caption)}>{option.caption}</div>
            )}
          </div>
          <Tag size='small' closable={false}>
            {alreadySharedLabel}
          </Tag>
        </div>
      ),
    };
  };
